import { render } from "./VabeneRestaurantClosuresPage.vue?vue&type=template&id=5fd16ac2&scoped=true&ts=true"
import script from "./VabeneRestaurantClosuresPage.vue?vue&type=script&lang=ts"
export * from "./VabeneRestaurantClosuresPage.vue?vue&type=script&lang=ts"

import "./VabeneRestaurantClosuresPage.vue?vue&type=style&index=0&id=5fd16ac2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd16ac2"]])

export default __exports__